import { ReactNode, useCallback, useMemo } from "react";
import { ITask } from "../types";
import { Row, Tag } from "antd";
import { SideBarContainer } from "../../../components/SideBarContainer";
import { Sidebar } from "../components/Sidebar";

export const useOpenSidebar = (
  isClosed: boolean,
  selectedItem: ITask | undefined,
  setSelectedItem: React.Dispatch<React.SetStateAction<ITask | undefined>>,
  setTaskIdToClose: React.Dispatch<React.SetStateAction<string | undefined>>,
  reload: () => void,
) => {
  const showSideBar = useCallback(
    (_: boolean) => {
      setSelectedItem(undefined);
    },
    [setSelectedItem],
  );

  const title: string | ReactNode = useMemo(() => {
    if (!selectedItem) {
      return "";
    }

    return (
      <Row className="align-center">
        <h4 className="my-0 h h4 title mr-4 elipsis" title={selectedItem.name}>
          {selectedItem.name}
        </h4>
        <Tag color={isClosed ? undefined : "orange"}>
          {isClosed ? "Closed" : "Open"}
        </Tag>
      </Row>
    );
  }, [isClosed, selectedItem]);

  const sidebar: ReactNode = useMemo(() => {
    return (
      <SideBarContainer title={title} setShowSideBar={showSideBar}>
        <Sidebar
          isClosed={isClosed}
          id={selectedItem?.id || ""}
          showSideBar={showSideBar}
          setTaskIdToClose={setTaskIdToClose}
          reload={reload}
        />
      </SideBarContainer>
    );
  }, [title, showSideBar, selectedItem, isClosed, setTaskIdToClose, reload]);

  return { sidebar };
};
